/*
 * @Descripttion:
 * @version:
 * @Author: kun.zhang
 * @Date: 2021-08-30 15:47:13
 * @LastEditors: kun.zhang
 * @LastEditTime: 2021-08-30 16:43:25
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;

export default {

  /**
   * 根据表单编码查询用户表单配置
   * @param {string} formCode 	form-code
   * @returns
   */
  getFormByCode(formCode) {
    return request({
      url: `${requestUrl}/form/user/form-code/${formCode}`,
      method: "get"
    });
  },

  /**
   * 保存用户表单展示列配置
   * @param {string} formCode 	form-code
   * @returns
   */
  saveFormColumn(formCode, data) {
    return request({
      url: `${requestUrl}/form/user/form-code/${formCode}/column-show`,
      method: "patch",
      data
    });
  },

  /**
   * 保存用户表单查询条件配置
   * @param {string} formCode 	form-code
   * @returns
   */
  saveFormQuery(formCode, data) {
    return request({
      url: `${requestUrl}/form/user/form-code/${formCode}/query-param`,
      method: "patch",
      data
    });
  },
  saveOrder(code, data) {
    return request({
      url: `${requestUrl}/form/user/form-code/${code}/orders`,
      method: "patch",
      data
    });
  }
};
